import { cn } from '@/lib/utils'

export default function Brand({ className }: { className?: string }) {
  return (
    <img
      src="/brand/maxfem-logo-rosa.png"
      alt="Maxfem"
      width={567}
      height={120}
      className={cn('h-auto w-32 sm:w-36', className)}
    />
  )
}
